import {gsap, TimelineLite} from "gsap";
import {DumpsterFire} from "../DumpsterFire";
import {DFGameConfig} from "../DFGameConfig";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";

export class BgMultiplierView extends PIXI.Container implements StageLayer {

    private _bitmapTextArray: PIXI.Sprite[] = [];

    constructor() {
        super();
        this.name = "BgMultiplierView";
    }

    public removeMulti(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._bitmapTextArray.forEach((item: PIXI.Sprite) => {
            tl.add(gsap.to(item, {alpha: 0, duration: 0.2}), 0);
            tl.add(() => {
                this.removeChild(item);
            }, 0.2)
        })
        return tl;
    }

    public largestMulti(): number {
        let largestValue: number = 2;
        for (let reelId: number = 0; reelId < DumpsterFire.model.data.positionMultipliers.length; reelId++) {
            for (let rowId: number = 0; rowId < DumpsterFire.model.data.positionMultipliers[reelId].length; rowId++) {
                let value: number = DumpsterFire.model.data.positionMultipliers[reelId][rowId];
                if (value > largestValue) {
                    largestValue = value
                }
            }
        }
        return largestValue;
    }

    public showMultipliers(reelId: number, rowId: number, multiValue: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (multiValue >= 8192) {
            DumpsterFire.model.isMaxMulti.push(6 * reelId + rowId);
        }
        if (multiValue > 1 && multiValue < 8193) {
            // DumpsterFire.soundPlayer.playSound(DumpsterFireSound.MULTI_UP);
            let animName: string = ""
            if (multiValue === 128 || multiValue === 256) {
                animName = "level1Flame_Loop"
            } else if (multiValue === 512 || multiValue === 1024) {
                animName = "level2Flame_Loop"
            } else if (multiValue === 2048 || multiValue === 4096) {
                animName = "level3Flame_Loop"
            } else if (multiValue === 8192) {
                animName = "level4Flame_Loop"
            }
            let spriteName: string = '';
            if (multiValue === 2 || multiValue === 4 || multiValue === 8) {
                spriteName = "plank1"
            } else if (multiValue === 16 || multiValue === 32 || multiValue === 64) {
                spriteName = "plank2"
            } else if (multiValue === 128 || multiValue === 256 || multiValue === 512) {
                spriteName = "plank3"
            } else if (multiValue === 1024 || multiValue === 2048 || multiValue === 4096 || multiValue === 8192) {
                spriteName = "plank4"
            }
            const multiText: PIXI.Sprite = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures(spriteName)[0]);
            tl.add([() => {
                multiText.alpha = 0;
                multiText.position.set(DFGameConfig.symbolWidth * reelId - 5, (DFGameConfig.symbolHeight * rowId) + 70);
                this.addChild(multiText);
            }], 0);
            if (animName !== "") {
                // tl.add(DumpsterFire.fireFrame.removeFireSpineFromMatrix(reelId, rowId), 0)
                tl.add(DumpsterFire.fireFrame.addFireAnimToMatrix(reelId, rowId, animName))
            }
            tl.to(multiText, {duration: 0.1, alpha: 1}, 0);
            this._bitmapTextArray.push(multiText);
        }
        return tl;
    }

}